// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"923b3828","73":"1a5b5869","129":"ed540cf0","265":"c4629784","428":"78fa7546","673":"bd60fbf1"}[chunkId] + ".css";
};